import { render } from "./product-list-item.vue?vue&type=template&id=049b2b87&scoped=true"
import script from "./product-list-item.vue?vue&type=script&lang=js"
export * from "./product-list-item.vue?vue&type=script&lang=js"

import "./product-list-item.vue?vue&type=style&index=0&id=049b2b87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049b2b87"]])

export default __exports__